import {useEffect} from 'react';
import { COMMAND_PRIORITY_NORMAL, KEY_ENTER_COMMAND} from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { ChatEditorToPlainString, ChatEditorToPlaintextBody } from '../formatters/chat';
import { clearAndFocusEditor } from '../functions/editor';

function EnterCommandPlugin({onEnter}: {onEnter: (...args: any) => void}) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerCommand(
        KEY_ENTER_COMMAND,
        (event: KeyboardEvent) => {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                if(ChatEditorToPlainString(editor).replaceAll('\n', '').length !== 0) {
                  onEnter(ChatEditorToPlaintextBody(editor));
                }
                
                clearAndFocusEditor(editor);
                return true;
            }
            return false;
        },
        COMMAND_PRIORITY_NORMAL
    );
  }, [editor, onEnter]);

  return null;
}

export default EnterCommandPlugin
